import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-xl px-3 py-2 shadow-warm-md border border-surface-200 text-sm space-y-1">
      <p className="font-semibold text-ink-800">{label}</p>
      {payload.map((p) => (
        <p key={p.dataKey} className="text-ink-500 flex items-center gap-2">
          <span className="inline-block w-2 h-2 rounded-full" style={{ backgroundColor: p.color }} />
          <span>{p.name}:</span>
          <span className="font-medium">{(p.value || 0).toLocaleString()}</span>
        </p>
      ))}
    </div>
  );
};

const IosDownloadsChart = ({ stats }) => {
  const data = (stats || []).map((s) => ({
    date: s.date?.slice(5) || s.id?.slice(5),
    firstTime: s.iosFirstTimeDownloads || 0,
    updates: s.iosUpdates || 0,
  }));

  const hasAnyData = data.some((d) => d.firstTime > 0 || d.updates > 0);

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-bold text-ink-900 text-[0.9375rem]">iOS downloads</h3>
        <span className="text-xs text-ink-400">Last 30 days</span>
      </div>
      <p className="text-xs text-ink-400 mb-5">
        First-time downloads vs updates from App Store Connect daily sales reports.
      </p>
      {hasAnyData ? (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e0d6" vertical={false} />
            <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#57534e' }} axisLine={{ stroke: '#e5e0d6' }} tickLine={false} />
            <YAxis tick={{ fontSize: 11, fill: '#57534e' }} axisLine={false} tickLine={false} allowDecimals={false} />
            <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(27, 107, 74, 0.05)' }} />
            <Legend iconType="circle" wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
            <Bar dataKey="firstTime" name="First-time" fill="#1B6B4A" radius={[4, 4, 0, 0]} />
            <Bar dataKey="updates" name="Updates" fill="#B8B2A8" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="h-[260px] flex flex-col items-center justify-center gap-2 bg-surface-50 rounded-xl border border-dashed border-surface-200">
          <p className="text-sm font-semibold text-ink-700">Awaiting App Store Connect credentials</p>
          <p className="text-xs text-ink-400 text-center max-w-sm px-4">
            Generate an App Store Connect API Key (Finance role), upload the .p8 and set
            APP_STORE_KEY_ID / APP_STORE_ISSUER_ID / APP_STORE_VENDOR_NUMBER as Firebase secrets.
          </p>
        </div>
      )}
    </div>
  );
};

export default IosDownloadsChart;
